var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-card', {
    staticClass: "custom-card"
  }, [_c('div', {
    staticClass: "card-layout",
    on: {
      "click": function click($event) {
        return _vm.$emit('click');
      }
    }
  }, [_c('card-inner-layout', {
    scopedSlots: _vm._u([{
      key: "icon",
      fn: function fn() {
        return [_vm.icons ? _c('event-icon', {
          attrs: {
            "event-type": _vm.item.type
          }
        }) : _c('img', {
          attrs: {
            "src": require("@/assets/event/icon/light/sheet.svg"),
            "alt": "Sheet icon"
          }
        })];
      },
      proxy: true
    }, {
      key: "header",
      fn: function fn() {
        return [_vm._v(" " + _vm._s(_vm.item.projectName) + " ")];
      },
      proxy: true
    }, {
      key: "name",
      fn: function fn() {
        return [_vm._v(" " + _vm._s(_vm.item.name) + " ")];
      },
      proxy: true
    }, _vm.item.description ? {
      key: "description",
      fn: function fn() {
        return [_vm.item.description.length < 150 ? [_vm._v(" " + _vm._s(_vm.item.description) + " ")] : [_vm._v(" " + _vm._s(_vm.item.description.substring(0, 150) + ' ...') + " ")]];
      },
      proxy: true
    } : null, {
      key: "date",
      fn: function fn() {
        return [_vm._v(" " + _vm._s(_vm.formatDate(_vm.item.startDate)) + " ")];
      },
      proxy: true
    }], null, true)
  })], 1), _vm.icons ? _c('div', {
    staticClass: "settings"
  }, [_c('div', {
    staticClass: "settings-area",
    attrs: {
      "id": "settings".concat(_vm.item.id),
      "tabindex": "0"
    }
  }, [_c('img', {
    staticClass: "pb-3",
    attrs: {
      "src": require("@/assets/dashboard/settings.svg"),
      "alt": "Settings icon"
    }
  })]), _c('b-popover', {
    attrs: {
      "target": "settings".concat(_vm.item.id),
      "triggers": "focus",
      "placement": "bottomleft"
    }
  }, [_c('div', {
    staticClass: "popover-wrapper"
  }, [_c('div', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal",
      value: "update-modal-".concat(_vm.item.id),
      expression: "`update-modal-${item.id}`"
    }],
    staticClass: "mx-auto mb-2 mt-1"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": require("@/assets/dashboard/edit-icon.svg"),
      "alt": "Edit icon"
    }
  }), _c('span', [_vm._v(" " + _vm._s(_vm.$t('dashboard.events.settings.edit')) + " ")])]), _vm.item.role === 'ADMINISTRATOR' ? _c('div', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal",
      value: "delete-modal-".concat(_vm.item.id),
      expression: "`delete-modal-${item.id}`"
    }],
    staticClass: "delete"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": require("@/assets/dashboard/trash-icon.svg"),
      "alt": "Delete icon"
    }
  }), _c('span', [_vm._v(" " + _vm._s(_vm.$t('dashboard.events.settings.delete')) + " ")])]) : _vm._e()])]), _c('custom-modal', {
    attrs: {
      "id": "update-modal-".concat(_vm.item.id),
      "title": _vm.$t('dashboard.events.form.update-title')
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function fn() {
        return [_c('create-event-modal', {
          attrs: {
            "is-update": "",
            "item": _vm.item
          },
          on: {
            "success": _vm.onClick,
            "close": function close($event) {
              return _vm.onClose(_vm.item);
            }
          }
        })];
      },
      proxy: true
    }], null, false, 2717314020)
  }), _c('confirmation-modal', {
    attrs: {
      "id": "delete-modal-".concat(_vm.item.id),
      "variant": "danger",
      "yes-key": "dashboard.events.delete.ok"
    },
    on: {
      "on-click-yes": _vm.deleteEvent
    },
    scopedSlots: _vm._u([{
      key: "body-text",
      fn: function fn() {
        return [_c('img', {
          staticClass: "modal-icon",
          attrs: {
            "src": require("@/assets/customer-project/danger.svg")
          }
        }), _c('h2', {
          staticClass: "modal-title"
        }, [_vm._v(" " + _vm._s(_vm.$t('dashboard.events.delete.title')) + " ")]), _c('p', {
          staticClass: "modal-p"
        }, [_vm._v(" " + _vm._s(_vm.$t('dashboard.events.delete.body')) + " ")])];
      },
      proxy: true
    }], null, false, 421672649)
  })], 1) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }